
import { Vue, Component, Prop } from 'vue-property-decorator';
import { Button, Dialog, Toast, Popup } from 'vant';
import { isWeiXin } from '@/common/ts/common';
import { vote } from '@/api/api';
import SlideVerify from '@/components/next/SlideVerify.vue';
import { Loading } from 'vant';
import qs from 'qs';
Vue.use(Popup)
  .use(Dialog)
  .use(Toast)
  .use(Button)
  .use(Loading);
@Component({
  components: {
    SlideVerify,
  },
})
export default class VoteButton extends Vue {
  @Prop() voteName!: string;
  @Prop() voteId!: string | number;
  @Prop({ default: false }) voteWeChat!: boolean;
  @Prop({ default: 10 }) MaxNum!: number;
  @Prop({ default: -1 }) voteIndex!: number;
  @Prop({ default: 0 }) source!: string;
  @Prop({
    default: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.news.shangyounews',
  })
  downLoadUrl!: string;

  showSlideVerify = false;
  pointOut = false;
  unionId!: string | null;
  loading: boolean = false;
  showDialog = false;
  dialogTitle = '友情提示';
  dialogContent = '请在上游新闻App进行点赞';
  throttleTimer: any = null;
  voteEnable = true;

  WechatLogin() {
    const { code, source } = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    });
    if (isWeiXin() && !code) {
      const appId = 'wx1949ed4a473b87ed';
      location.href = `https://activity.cqcb.com/wechat-auth.html?appId=${appId}&backUrl=${encodeURIComponent(
        location.href,
      )}`;
    }
  }
  AppLogin() {
    const token = window.gettoken();
    if (token === 'null' || !token) {
      if (parseFloat(window.version) >= 4.5) {
        window.handleMessage('{"action":"mUserLogin","data":""}');
      } else {
        window.location.href = 'client:logout';
      }
      return;
    }
  }
  WechatLoginReset() {
    const { code, source } = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    });
    if (isWeiXin()) {
      const appId = 'wx1949ed4a473b87ed';
      location.href = `https://activity.cqcb.com/wechat-auth.html?appId=${appId}&backUrl=${encodeURIComponent(
        location.href,
      )}`;
    }
  }
  async onVote() {
    // DONE 大量代码需重构
    // 微信环境中引导用户登录(若需要)
    this.unionId = window.localStorage.getItem('unionid');
    if (!isWeiXin() && !window.udid) {
      Toast('请在微信或者上游APP打开');
      return;
    } else if (!this.unionId && isWeiXin()) {
      this.WechatLogin();
    } else if (window.udid) {
      this.AppLogin();
    }
    // if (
    //   this.voteWeChat &&
    //   isWeiXin() &&
    //   !window.localStorage.getItem('unionid')
    // ) {
    //   this.$dialog
    //     .confirm({
    //       title: '微信登录',
    //       message: '点赞前需要进行微信登录',
    //     })
    //     .then(() => {
    //       console.log('确定');
    //       this.WechatLogin();
    //       this.loading = false;
    //     })
    //     .catch(() => {
    //       console.log('取消');
    //       this.loading = false;
    //     });
    //   return;
    // }

    // 开始投票，微信环境和App环境传递参数有所不同
    let apiData: any = {};
    if (this.voteWeChat && isWeiXin()) {
      this.unionId = window.localStorage.getItem('unionid');
      apiData = {
        id: this.voteId,
        unionid: this.unionId,
        source: this.source,
      };
    } else if (window.udid) {
      apiData = {
        id: this.voteId,
        udid: window.udid,
        appkey: window.appkey,
        source: this.source,
      };
    } else {
      this.$dialog
        .confirm({
          title: '友情提示',
          message: '请在上游新闻App进行投票',
          confirmButtonText: '还没装？一步安装',
          cancelButtonText: '我已安装过',
          closeOnClickOverlay: true,
        })
        .then((action) => {
          console.log(action);
          window.location.href = this.downLoadUrl;
        })
        .catch((action) => {
          console.log(action);
          if (action === 'overlay') {
            // 忽略掉点击遮罩层的关闭行为
            return;
          }
          if (isWeiXin()) {
            this.pointOut = true;
          } else {
            window.location.href =
              'shangyounews://{"dt":"7","url":"' +
              document.location.href +
              '"}';
          }
        });
      return;
    }
    // if (this.voteWeChat && isWeiXin()) {
    //   this.unionId = window.localStorage.getItem('unionid');
    //   apiData = {
    //     id: this.voteId,
    //     unionid: this.unionId,
    //     source: this.source,
    //   };
    // } else {
    //   return Toast('请在微信里投票');
    // }
    // 节流
    if (!this.voteEnable) {
      return Toast('手速不要太快哦');
    }
    this.voteEnable = false;
    clearTimeout(this.throttleTimer);
    this.throttleTimer = setTimeout(() => {
      this.voteEnable = true;
    }, 3000);

    const result = await vote(this.voteName, apiData);
    this.successVote(result);
  }
  fSlideData(res: any) {
    this.showSlideVerify = false;
    // if (this.voteWeChat && isWeiXin()) {
    //   const data = {
    //     id: this.voteId,
    //     unionid: this.unionId,
    //     source: this.source,
    //   };
    //   const lastData = Object.assign(res, data);
    //   vote(this.voteName, lastData).then((result: any) =>
    //     this.successVote(result),
    //   );
    // } else {
    //   return Toast('请在微信里投票');
    // }
    let apiData: any = {};
    if (this.voteWeChat && isWeiXin()) {
      this.unionId = window.localStorage.getItem('unionid');
      apiData = {
        id: this.voteId,
        unionid: this.unionId,
        source: this.source,
      };
    } else if (window.udid) {
      apiData = {
        id: this.voteId,
        udid: window.udid,
        appkey: window.appkey,
        source: this.source,
      };
    } else {
      this.$dialog
        .confirm({
          title: '友情提示',
          message: '请在上游新闻App进行投票',
          confirmButtonText: '还没装？一步安装',
          cancelButtonText: '我已安装过',
          closeOnClickOverlay: true,
        })
        .then((action) => {
          console.log(action);
          window.location.href = this.downLoadUrl;
        })
        .catch((action) => {
          console.log(action);
          if (action === 'overlay') {
            // 忽略掉点击遮罩层的关闭行为
            return;
          }
          if (isWeiXin()) {
            this.pointOut = true;
          } else {
            window.location.href =
              'shangyounews://{"dt":"7","url":"' +
              document.location.href +
              '"}';
          }
        });
      return;
    }
    const lastData = Object.assign(res, apiData);
    vote(this.voteName, lastData).then((result: any) =>
      this.successVote(result),
    );
  }
  successVote(res: any) {
    switch (res.code) {
      case 200:
        Toast({
          type: 'success',
          duration: 1200,
          message: res.msg,
        });
        this.$emit('votSuccess', res.data, this.voteIndex);
        break;
      case 201:
        // 需要滑动验证
        this.showSlideVerify = true;
        break;
      case 202:
        if (parseFloat(window.version) >= 4.5) {
          // 需要在App内登录
          window.handleMessage('{"action":"mUserLogin","data":""}');
        } else {
          // 老版本唤起App登录页面栈
          window.location.href = 'client:logout';
        }
        break;
      case 203:
        // 超出投票规定次数
        if (this.voteWeChat && isWeiXin()) {
          Toast.fail('今日投票数已用完，请明天再试！');
        } else {
          Toast.fail(res.msg);
        }
        break;
      case 505:
        localStorage.removeItem('unionid');
        window.location.reload();
        break;
      case 500:
      case 204:
      case 300:
      case 101:
        Toast.fail(res.msg);
        break;
    }
  }
}
